import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Disposable } from '../../../base/common/lifecycle.js';
import { IBulkEditService } from '../../browser/services/bulkEditService.js';
import { ICodeEditorService } from '../../browser/services/codeEditorService.js';
import { IEditorWorkerService } from '../../common/services/editorWorkerService.js';
import { EditorWorkerServiceImpl } from '../../common/services/editorWorkerServiceImpl.js';
import { IModeService } from '../../common/services/modeService.js';
import { ModeServiceImpl } from '../../common/services/modeServiceImpl.js';
import { IModelService } from '../../common/services/modelService.js';
import { ModelServiceImpl } from '../../common/services/modelServiceImpl.js';
import { ITextResourceConfigurationService, ITextResourcePropertiesService } from '../../common/services/textResourceConfigurationService.js';
import { SimpleBulkEditService, SimpleConfigurationService, SimpleDialogService, SimpleNotificationService, SimpleEditorProgressService, SimpleResourceConfigurationService, SimpleResourcePropertiesService, SimpleUriLabelService, SimpleWorkspaceContextService, StandaloneCommandService, StandaloneKeybindingService, StandaloneTelemetryService, SimpleLayoutService } from './simpleServices.js';
import { StandaloneCodeEditorServiceImpl } from './standaloneCodeServiceImpl.js';
import { StandaloneThemeServiceImpl } from './standaloneThemeServiceImpl.js';
import { IStandaloneThemeService } from '../common/standaloneThemeService.js';
import { IMenuService } from '../../../platform/actions/common/actions.js';
import { ICommandService } from '../../../platform/commands/common/commands.js';
import { IConfigurationService } from '../../../platform/configuration/common/configuration.js';
import { ContextKeyService } from '../../../platform/contextkey/browser/contextKeyService.js';
import { IContextKeyService } from '../../../platform/contextkey/common/contextkey.js';
import { ContextMenuService } from '../../../platform/contextview/browser/contextMenuService.js';
import { IContextMenuService, IContextViewService } from '../../../platform/contextview/browser/contextView.js';
import { ContextViewService } from '../../../platform/contextview/browser/contextViewService.js';
import { IDialogService } from '../../../platform/dialogs/common/dialogs.js';
import { IInstantiationService, createDecorator } from '../../../platform/instantiation/common/instantiation.js';
import { InstantiationService } from '../../../platform/instantiation/common/instantiationService.js';
import { ServiceCollection } from '../../../platform/instantiation/common/serviceCollection.js';
import { IKeybindingService } from '../../../platform/keybinding/common/keybinding.js';
import { ILabelService } from '../../../platform/label/common/label.js';
import { IListService, ListService } from '../../../platform/list/browser/listService.js';
import { ConsoleLogService, ILogService } from '../../../platform/log/common/log.js';
import { MarkerService } from '../../../platform/markers/common/markerService.js';
import { IMarkerService } from '../../../platform/markers/common/markers.js';
import { INotificationService } from '../../../platform/notification/common/notification.js';
import { IEditorProgressService } from '../../../platform/progress/common/progress.js';
import { IStorageService, InMemoryStorageService } from '../../../platform/storage/common/storage.js';
import { ITelemetryService } from '../../../platform/telemetry/common/telemetry.js';
import { IThemeService } from '../../../platform/theme/common/themeService.js';
import { IWorkspaceContextService } from '../../../platform/workspace/common/workspace.js';
import { MenuService } from '../../../platform/actions/common/menuService.js';
import { IMarkerDecorationsService } from '../../common/services/markersDecorationService.js';
import { MarkerDecorationsService } from '../../common/services/markerDecorationsServiceImpl.js';
import { IAccessibilityService } from '../../../platform/accessibility/common/accessibility.js';
import { ILayoutService } from '../../../platform/layout/browser/layoutService.js';
import { getSingletonServiceDescriptors } from '../../../platform/instantiation/common/extensions.js';
import { AccessibilityService } from '../../../platform/accessibility/common/accessibilityService.js';
import { IClipboardService } from '../../../platform/clipboard/common/clipboardService.js';
import { BrowserClipboardService } from '../../../platform/clipboard/browser/clipboardService.js';
import { IUndoRedoService } from '../../../platform/undoRedo/common/undoRedo.js';
import { UndoRedoService } from '../../../platform/undoRedo/common/undoRedoService.js';
import { StandaloneQuickInputServiceImpl } from './quickInput/standaloneQuickInputServiceImpl.js';
import { IQuickInputService } from '../../../platform/quickinput/common/quickInput.js';
import { IStorageKeysSyncRegistryService, StorageKeysSyncRegistryService } from '../../../platform/userDataSync/common/storageKeys.js';
export var StaticServices;

(function (StaticServices) {
  var _serviceCollection = new ServiceCollection();

  var LazyStaticService = /*#__PURE__*/function () {
    function LazyStaticService(serviceId, factory) {
      _classCallCheck(this, LazyStaticService);

      this._serviceId = serviceId;
      this._factory = factory;
      this._value = null;
    }

    _createClass(LazyStaticService, [{
      key: "id",
      get: function get() {
        return this._serviceId;
      }
    }, {
      key: "get",
      value: function get(overrides) {
        if (!this._value) {
          if (overrides) {
            this._value = overrides[this._serviceId.toString()];
          }

          if (!this._value) {
            this._value = this._factory(overrides);
          }

          if (!this._value) {
            throw new Error('Service ' + this._serviceId + ' is missing!');
          }

          _serviceCollection.set(this._serviceId, this._value);
        }

        return this._value;
      }
    }]);

    return LazyStaticService;
  }();

  StaticServices.LazyStaticService = LazyStaticService;
  var _all = [];

  function define(serviceId, factory) {
    var r = new LazyStaticService(serviceId, factory);

    _all.push(r);

    return r;
  }

  function init(overrides) {
    // Create a fresh service collection
    var result = new ServiceCollection(); // make sure to add all services that use `registerSingleton`

    var _iterator = _createForOfIteratorHelper(getSingletonServiceDescriptors()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            id = _step$value[0],
            descriptor = _step$value[1];

        result.set(id, descriptor);
      } // Initialize the service collection with the overrides

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    for (var serviceId in overrides) {
      if (overrides.hasOwnProperty(serviceId)) {
        result.set(createDecorator(serviceId), overrides[serviceId]);
      }
    } // Make sure the same static services are present in all service collections


    _all.forEach(function (service) {
      return result.set(service.id, service.get(overrides));
    }); // Ensure the collection gets the correct instantiation service


    var instantiationService = new InstantiationService(result, true);
    result.set(IInstantiationService, instantiationService);
    return [result, instantiationService];
  }

  StaticServices.init = init;
  StaticServices.instantiationService = define(IInstantiationService, function () {
    return new InstantiationService(_serviceCollection, true);
  });
  var configurationServiceImpl = new SimpleConfigurationService();
  StaticServices.configurationService = define(IConfigurationService, function () {
    return configurationServiceImpl;
  });
  StaticServices.resourceConfigurationService = define(ITextResourceConfigurationService, function () {
    return new SimpleResourceConfigurationService(configurationServiceImpl);
  });
  StaticServices.resourcePropertiesService = define(ITextResourcePropertiesService, function () {
    return new SimpleResourcePropertiesService(configurationServiceImpl);
  });
  StaticServices.contextService = define(IWorkspaceContextService, function () {
    return new SimpleWorkspaceContextService();
  });
  StaticServices.labelService = define(ILabelService, function () {
    return new SimpleUriLabelService();
  });
  StaticServices.telemetryService = define(ITelemetryService, function () {
    return new StandaloneTelemetryService();
  });
  StaticServices.dialogService = define(IDialogService, function () {
    return new SimpleDialogService();
  });
  StaticServices.notificationService = define(INotificationService, function () {
    return new SimpleNotificationService();
  });
  StaticServices.markerService = define(IMarkerService, function () {
    return new MarkerService();
  });
  StaticServices.modeService = define(IModeService, function (o) {
    return new ModeServiceImpl();
  });
  StaticServices.standaloneThemeService = define(IStandaloneThemeService, function () {
    return new StandaloneThemeServiceImpl();
  });
  StaticServices.logService = define(ILogService, function () {
    return new ConsoleLogService();
  });
  StaticServices.undoRedoService = define(IUndoRedoService, function (o) {
    return new UndoRedoService(StaticServices.dialogService.get(o), StaticServices.notificationService.get(o));
  });
  StaticServices.modelService = define(IModelService, function (o) {
    return new ModelServiceImpl(StaticServices.configurationService.get(o), StaticServices.resourcePropertiesService.get(o), StaticServices.standaloneThemeService.get(o), StaticServices.logService.get(o), StaticServices.undoRedoService.get(o));
  });
  StaticServices.markerDecorationsService = define(IMarkerDecorationsService, function (o) {
    return new MarkerDecorationsService(StaticServices.modelService.get(o), StaticServices.markerService.get(o));
  });
  StaticServices.codeEditorService = define(ICodeEditorService, function (o) {
    return new StandaloneCodeEditorServiceImpl(StaticServices.standaloneThemeService.get(o));
  });
  StaticServices.editorProgressService = define(IEditorProgressService, function () {
    return new SimpleEditorProgressService();
  });
  StaticServices.storageService = define(IStorageService, function () {
    return new InMemoryStorageService();
  });
  StaticServices.storageSyncService = define(IStorageKeysSyncRegistryService, function () {
    return new StorageKeysSyncRegistryService();
  });
  StaticServices.editorWorkerService = define(IEditorWorkerService, function (o) {
    return new EditorWorkerServiceImpl(StaticServices.modelService.get(o), StaticServices.resourceConfigurationService.get(o), StaticServices.logService.get(o));
  });
})(StaticServices || (StaticServices = {}));

export var DynamicStandaloneServices = /*#__PURE__*/function (_Disposable) {
  _inherits(DynamicStandaloneServices, _Disposable);

  var _super = _createSuper(DynamicStandaloneServices);

  function DynamicStandaloneServices(domElement, overrides) {
    var _this;

    _classCallCheck(this, DynamicStandaloneServices);

    _this = _super.call(this);

    var _StaticServices$init = StaticServices.init(overrides),
        _StaticServices$init2 = _slicedToArray(_StaticServices$init, 2),
        _serviceCollection = _StaticServices$init2[0],
        _instantiationService = _StaticServices$init2[1];

    _this._serviceCollection = _serviceCollection;
    _this._instantiationService = _instantiationService;

    var configurationService = _this.get(IConfigurationService);

    var notificationService = _this.get(INotificationService);

    var telemetryService = _this.get(ITelemetryService);

    var themeService = _this.get(IThemeService);

    var logService = _this.get(ILogService);

    var ensure = function ensure(serviceId, factory) {
      var value = null;

      if (overrides) {
        value = overrides[serviceId.toString()];
      }

      if (!value) {
        value = factory();
      }

      _this._serviceCollection.set(serviceId, value);

      return value;
    };

    var contextKeyService = ensure(IContextKeyService, function () {
      return _this._register(new ContextKeyService(configurationService));
    });
    ensure(IAccessibilityService, function () {
      return new AccessibilityService(contextKeyService, configurationService);
    });
    ensure(IListService, function () {
      return new ListService(themeService);
    });
    var commandService = ensure(ICommandService, function () {
      return new StandaloneCommandService(_this._instantiationService);
    });
    var keybindingService = ensure(IKeybindingService, function () {
      return _this._register(new StandaloneKeybindingService(contextKeyService, commandService, telemetryService, notificationService, logService, domElement));
    });
    var layoutService = ensure(ILayoutService, function () {
      return new SimpleLayoutService(StaticServices.codeEditorService.get(ICodeEditorService), domElement);
    });
    ensure(IQuickInputService, function () {
      return new StandaloneQuickInputServiceImpl(_instantiationService, StaticServices.codeEditorService.get(ICodeEditorService));
    });
    var contextViewService = ensure(IContextViewService, function () {
      return _this._register(new ContextViewService(layoutService));
    });
    ensure(IClipboardService, function () {
      return new BrowserClipboardService();
    });
    ensure(IContextMenuService, function () {
      var contextMenuService = new ContextMenuService(telemetryService, notificationService, contextViewService, keybindingService, themeService);
      contextMenuService.configure({
        blockMouse: false
      }); // we do not want that in the standalone editor

      return _this._register(contextMenuService);
    });
    ensure(IMenuService, function () {
      return new MenuService(commandService);
    });
    ensure(IBulkEditService, function () {
      return new SimpleBulkEditService(StaticServices.modelService.get(IModelService));
    });
    return _this;
  }

  _createClass(DynamicStandaloneServices, [{
    key: "get",
    value: function get(serviceId) {
      var r = this._serviceCollection.get(serviceId);

      if (!r) {
        throw new Error('Missing service ' + serviceId);
      }

      return r;
    }
  }, {
    key: "set",
    value: function set(serviceId, instance) {
      this._serviceCollection.set(serviceId, instance);
    }
  }, {
    key: "has",
    value: function has(serviceId) {
      return this._serviceCollection.has(serviceId);
    }
  }]);

  return DynamicStandaloneServices;
}(Disposable);